import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './JobSurveyFalsification.styles';

const JobSurveyFalsificationSummary = props => {
  const { t } = useTranslation();
  const { jobSurveyFalsificationSummary } = props;

  const surveyDataFalsificationSummary =
    jobSurveyFalsificationSummary?.surveyDataFalsificationSummary;
  let completedResponse = surveyDataFalsificationSummary?.totalResponses || 0;
  const partialResponseRule = (surveyDataFalsificationSummary?.rulesSummary || []).filter(rule => rule.rule === 'PARTIAL_RESPONSE')[0];
  if (partialResponseRule) {
    completedResponse = surveyDataFalsificationSummary?.totalResponses - partialResponseRule.failedResponses;
  }
  const surveyDataFalsificationSummaryWithPercentage = {
    ...surveyDataFalsificationSummary,
    completedResponse,
    totalValidPercentage:
      surveyDataFalsificationSummary?.totalResponses > 0
        ? +(
            (surveyDataFalsificationSummary.totalValid * 100) /
            surveyDataFalsificationSummary.totalResponses
          ).toFixed(2)
        : '',
    totalInvalidPercentage:
      surveyDataFalsificationSummary?.totalResponses > 0
        ? +(
            (surveyDataFalsificationSummary.totalInvalid * 100) /
            surveyDataFalsificationSummary.totalResponses
          ).toFixed(2)
        : '',
    rulesSummary: surveyDataFalsificationSummary?.rulesSummary.map(rule => {
      return {
        ...rule,
        failedResponsesPercentage:
          surveyDataFalsificationSummary?.totalResponses > 0
            ? +(
                (rule.failedResponses * 100) /
                surveyDataFalsificationSummary?.totalResponses
              ).toFixed(2)
            : '',
      };
    }),
  };

  return (
    <>
      {surveyDataFalsificationSummaryWithPercentage && (
        <>
          <s.TableRow>
            <s.ColumnSummary header>{t('TOTAL_RESPONSES')}:</s.ColumnSummary>
            <s.ColumnSummary header col2 content>
              {surveyDataFalsificationSummaryWithPercentage.totalResponses}
            </s.ColumnSummary>
          </s.TableRow>
          <s.TableRow>
            <s.ColumnSummary>{t('COMPLETED')}:</s.ColumnSummary>
            <s.ColumnSummary col2 content>
              {surveyDataFalsificationSummaryWithPercentage.completedResponse}
            </s.ColumnSummary>
          </s.TableRow>
          {surveyDataFalsificationSummaryWithPercentage.rulesSummary?.map(
            rule => (
              <s.TableRow key={rule.rule}>
                <s.ColumnSummary>{t(rule.rule)} #:</s.ColumnSummary>
                <s.ColumnSummary content>
                  {rule.failedResponses}
                </s.ColumnSummary>
                <s.ColumnSummary content>
                  {rule.failedResponsesPercentage
                    ? `${rule.failedResponsesPercentage}%`
                    : ''}
                </s.ColumnSummary>
              </s.TableRow>
            ),
          )}
          <s.TableRow>
            <s.ColumnSummary>{t('VALID')} :</s.ColumnSummary>
            <s.ColumnSummary content>
              {surveyDataFalsificationSummaryWithPercentage.totalValid}
            </s.ColumnSummary>
            <s.ColumnSummary content>
              {surveyDataFalsificationSummaryWithPercentage.totalValidPercentage
                ? `${surveyDataFalsificationSummaryWithPercentage.totalValidPercentage}%`
                : ''}
            </s.ColumnSummary>
          </s.TableRow>
          <s.TableRow>
            <s.ColumnSummary>{t('INVALID')} :</s.ColumnSummary>
            <s.ColumnSummary content>
              {surveyDataFalsificationSummaryWithPercentage.totalInvalid}
            </s.ColumnSummary>
            <s.ColumnSummary content>
              {surveyDataFalsificationSummaryWithPercentage.totalInvalidPercentage
                ? `${surveyDataFalsificationSummaryWithPercentage.totalInvalidPercentage}%`
                : ''}
            </s.ColumnSummary>
          </s.TableRow>
          <s.TableRow>
            <s.ColumnSummary>{t('FALSIFICATION_ALERT')} #:</s.ColumnSummary>
            <s.ColumnSummary
              col2
              content
            >
              {surveyDataFalsificationSummaryWithPercentage.falsificationAlertCount}
            </s.ColumnSummary>
          </s.TableRow>
          <s.TableRow>
            <s.ColumnSummary>{t('SEVERITY_LEVEL')} %</s.ColumnSummary>
            <s.ColumnSummary
              col2
              content
            >
              {surveyDataFalsificationSummaryWithPercentage.severityLevelPercent}
            </s.ColumnSummary>
          </s.TableRow>
          <s.TableRow>
            <s.ColumnSummary>{t('SEVERITY_LEVEL_ALERT')}</s.ColumnSummary>
            <s.ColumnSummary
              col2
              content
            >
              {surveyDataFalsificationSummaryWithPercentage.severityLevelAlert}
            </s.ColumnSummary>
          </s.TableRow>
        </>
      )}
    </>
  );
};

export default React.memo(JobSurveyFalsificationSummary);
